
export default function FlagFR({
  width = 16,
  height = 16
}) {
  return (
    <svg
      height={width}
      width={height}
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <g>
          <path d="m173.167 95.677h-149.635c-8.854 0-16.032 7.178-16.032 16.032v288.581c0 8.854 7.178 16.032 16.032 16.032h149.635l18.704-24.052v-272.541z" fill="#5055a0" />
          <path d="m185.635 392.274h-114.006c-22.1 0-40.081-17.98-40.081-40.081v-256.516h-8.016c-8.854 0-16.032 7.178-16.032 16.032v288.581c0 8.854 7.179 16.032 16.032 16.032h149.635l18.702-24.048z" fill="#3f3f8f" />
          <path d="m338.833 416.323h149.635c8.854 0 16.032-7.178 16.032-16.032v-288.581c0-8.854-7.178-16.032-16.032-16.032h-149.635l-18.704 24.052v272.542z" fill="#e5646e" />
          <path d="m504.5 400.29v-8.016h-184.369l18.702 24.048h149.635c8.854.001 16.032-7.177 16.032-16.032z" fill="#db4655" />
          <path d="m173.167 95.677h165.666v320.645h-165.666z" fill="#f2f2f6" />
          <path d="m173.167 392.274h165.666v24.048h-165.666z" fill="#e1e1e6" /></g>
        <path d="m488.468 88.178h-464.936c-12.975 0-23.532 10.556-23.532 23.532v288.58c0 12.976 10.557 23.532 23.532 23.532h464.936c12.976 0 23.532-10.556 23.532-23.532v-288.58c0-12.976-10.557-23.532-23.532-23.532zm8.532 312.112c0 4.705-3.828 8.532-8.532 8.532h-142.135v-249.016c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v249.017h-150.666v-24.564c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v24.564h-142.135c-4.705 0-8.532-3.827-8.532-8.532v-288.581c0-4.705 3.828-8.532 8.532-8.532h142.134v249.017c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-249.017h150.667v24.564c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-24.564h142.134c4.705 0 8.532 3.827 8.532 8.532v288.58z" /></g></svg>

  )
}